/**
 * The default ARIA label for the WeekNumber element.
 */
export var labelWeekNumber = function (n) {
    return "Week n. " + n;
};
//# sourceMappingURL=labelWeekNumber.js.map